
import { defineComponent } from 'vue';

import CoffeeIcon from '@/assets/icons/bmc-black.svg';

export default defineComponent({
  name: 'About',
  components: { CoffeeIcon }
});
